import React, { useState } from 'react';
import { ROLES } from '../utils/roles';
import './EditCensorModal.css'; // Vi genbruger CSS'en da designet er ens

const CreateCensorModal = ({ onClose, onCreate, user, centers }) => {

  // LOGIK: Sæt default ID
  // Hvis SC_ADMIN: Brug deres eget ID.
  // Hvis ADMIN: Start tom (eller med det første center i listen)
  const defaultScId = user.role === ROLES.SC_ADMIN ? user.scId : '';

  const [formData, setFormData] = useState({
    fornavn: '', efternavn: '', email: '', telefon: '',
    arbejds_status: 'Tilgængelig',
    sprogcenter_id: defaultScId,
    adresse: '', postnummer: '', forstad: ''
  });

  // State til de 5 checkboxes
  const [exams, setExams] = useState({
    PD1: false,
    PD2: false,
    PD3: false,
    SP: false,
    VP: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheck = (key) => {
    setExams(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.role === ROLES.ADMIN && !formData.sprogcenter_id) {
      alert('Vælg venligst et sprogcenter'); return;
    }

    // Flat data structure til API
    const finalData = {
      ...formData,
      beskikket_pd1: exams.PD1,
      beskikket_pd2: exams.PD2,
      beskikket_pd3: exams.PD3,
      beskikket_sp: exams.SP,
      beskikket_vp: exams.VP,
      // Vi sender stadig en 'beskikket_til' for bagudkompatibilitet i frontend lister midlertidigt
      beskikket_til: 'Multi' 
    };

    onCreate(finalData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <h2 className="modal-title">Opret underviser/censor</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-form-grid">

            {user.role === ROLES.ADMIN && (
              <div className="form-group full-width">
                <label>Tilknyttet Sprogcenter</label>
                <select
                  name="sprogcenter_id"
                  value={formData.sprogcenter_id}
                  onChange={handleChange}
                  style={{ width: '100%', padding: '10px', border: '2px solid #003366', background: '#f0f4f8' }}
                  required
                >
                  <option value="">-- Vælg Sprogcenter --</option>
                  {centers.map(sc => (
                    <option key={sc.id} value={sc.id}>
                      {sc.navn}
                    </option>
                  ))}
                </select>
              </div>
            )}


            <div className="form-group">
              <label>Fornavn</label>
              <input name="fornavn" value={formData.fornavn} onChange={handleChange} required placeholder="F.eks. Hanne" />
            </div>

            <div className="form-group">
              <label>Efternavn</label>
              <input name="efternavn" value={formData.efternavn} onChange={handleChange} required placeholder="F.eks. Hansen" />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mail@skole.dk" />
            </div>

            <div className="form-group">
              <label>Telefon</label>
              <input name="telefon" value={formData.telefon} onChange={handleChange} placeholder="12 34 56 78" />
            </div>

            <div className="form-group full-width" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px' }}>
              <div>
                <label>Adresse</label>
                <input name="adresse" value={formData.adresse} onChange={handleChange} placeholder="Gadevej 1" />
              </div>
              <div>
                <label>Postnr</label>
                <input name="postnummer" value={formData.postnummer} onChange={handleChange} placeholder="1234" />
              </div>
              <div>
                <label>By</label>
                <input name="forstad" value={formData.forstad} onChange={handleChange} placeholder="By" />
              </div>
            </div>

            <div className="form-group">
              <label>Arbejds Status</label>
              <select name="arbejds_status" value={formData.arbejds_status} onChange={handleChange} style={{ width: '100%', padding: '10px' }}>
                <option value="Tilgængelig">Tilgængelig</option>
                <option value="Pause">Pause</option>
                <option value="Sygemeldt">Sygemeldt</option>
                <option value="Orlov">Orlov</option>
                <option value="Barsel">Barsel</option>
                <option value="Ferie">Ferie</option>
                <option value="Inaktiv">Inaktiv</option>
              </select>
            </div>

            <div style={{marginTop: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef'}}>
              <label style={{display:'block', marginBottom:'10px', fontWeight:'600', color:'#555'}}>Beskikkelser (Sæt kryds)</label>
              <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                {['PD1', 'PD2', 'PD3', 'SP', 'VP'].map(type => (
                  <label key={type} style={{display:'flex', alignItems:'center', gap:'5px', cursor:'pointer', userSelect:'none'}}>
                    <input 
                      type="checkbox" 
                      checked={exams[type]} 
                      onChange={() => handleCheck(type)}
                      style={{width:'16px', height:'16px'}}
                    />
                    {type}
                  </label>
                ))}
              </div>
            </div>

          </div>

          


          {/* Kun Gem og Annuller her */}
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
            <button type="submit" className="btn-save">Opret Person</button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default CreateCensorModal;